import { IAreaPart } from '@cian/api-models/offer-card/v1/get-offer-data';
import { numberToPrettyString } from '@cian/utils';
import { CurrencySymbol } from './formatters';

export const getIsAnnual = (paymentPeriod: string | undefined) => paymentPeriod === 'annual';

export const getIsRent = (paymentPeriod?: string): boolean => {
  return paymentPeriod !== undefined && (paymentPeriod === 'annual' || paymentPeriod === 'monthly');
};

export const getPrice = (
  isAnnual?: boolean,
  isRent?: boolean,
  priceType?: string,
  paymentPeriod?: string,
  part?: IAreaPart,
): string => {
  if (part && part.price) {
    const { price } = part;

    return `${numberToPrettyString(price)} ${CurrencySymbol.Rur}${isRent ? '/мес' : ''}`;
  }

  return '';
};

export const getPriceOfMeter = (
  isAnnual?: boolean,
  isRent?: boolean,
  priceType?: string,
  paymentPeriod?: string,
  part?: IAreaPart,
): string => {
  if (part) {
    const { area, price } = part;

    if (price && area) {
      const pricePrepared = Math.round(isRent ? (price * 12) / area : price / area);

      return `${numberToPrettyString(pricePrepared)} ${CurrencySymbol.Rur} за м²${isRent ? '/год' : ''}`;
    }
  }

  return '';
};
